import { SectionHeader } from '@/components/ui/SectionHeader'
import { Reveal } from '@/components/ui/Reveal'
import { phases } from '@/data/work-with-me-content'

export const ProgrammeJourney = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <SectionHeader title="Your" accent="12-week journey" />
      <ol className="grid gap-6 lg:grid-cols-3">
        {phases.map((phase, index) => (
          <li key={phase.title}>
            <Reveal delay={index * 100} className="h-full">
              <div className="flex h-full flex-col rounded-3xl border border-base-200 bg-base-50 p-7 transition-colors hover:border-green-300">
                <span className="mb-4 inline-flex w-fit items-center rounded-full bg-green-950 px-3 py-1.5 text-xs font-medium text-base-50">
                  {phase.weeks}
                </span>
                <h3 className="mb-4 font-display text-2xl leading-tight text-base-900">
                  {phase.title}
                </h3>
                <div className="space-y-3 text-sm leading-6 text-base-600">
                  {phase.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  </section>
)
